import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';

import Icon from '../../../../Icon';
import styles from './index.styl';

const ConfirmedIcon = () => {
  const { formatMessage } = useIntl();

  return (
    <Fragment>
      <Icon name="icon-signed-consent" size={12} className={styles.icon} />
      <div className={styles.confirmedStatusTitle}>
        {formatMessage({ id: 'common.confirmed' })}
      </div>
    </Fragment>
  );
};

export default ConfirmedIcon;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentDetailsPopup/ConfirmedIcon/index.jsx